import React, { ReactElement } from "react";
import { Permission, PortalSettingsLinkVisibility } from "../../__generated__/api";
import usePortal from "../../contexts/PortalContext";
import useCurrentSession from "../../contexts/session";
import Styles from "./Footer.module.scss";

function Footer(): ReactElement {
    const { navigation } = usePortal();
    const { permissions } = useCurrentSession();
    return (
        <footer className={Styles.footer}>
            <small>
                Powered by
                {" "}
                <a
                    href="https://foqal.io/try-foqal?utm_source=product&utm_medium=footer&utm_campaign=foqal_product"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Foqal
                </a>
            </small>
            <small className={Styles["footer-links"]}>

                {navigation?.links?.filterMap(link => (
                    <a
                        href={link.url as string}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={link.text as string}
                    >
                        {link.text}
                    </a>
                ), link => (permissions.has(Permission.Administrator)
                    ? link.visibility !== PortalSettingsLinkVisibility.Public
                    : link.visibility !== PortalSettingsLinkVisibility.Internal))}
            </small>
        </footer>
    );
}

export default Footer;
